module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.7.2-130.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.7.2.md
// module id = 548
// module chunks = 249